import { ConnectedProps, legacy_connect as connect } from 'react-redux';

import UniqueId from '../../../services/uid/UniqueId';
import { AppState } from '../../../store/reducers/root';
import { getCategoryLayoutElement } from '../../../store/selectors/category';
import categoryActions from '../../../store/slices/category';

import CategoryLayoutElement from './CategoryLayoutElement';

interface Props {
  categoryId: UniqueId;
  elementId: UniqueId;
  showCommands: boolean;
}

const mapStateToProps = (
  state: AppState,
  { categoryId, elementId, showCommands }: Props
) => ({
  element: getCategoryLayoutElement(state, categoryId, elementId),
  categoryId,
  showCommands,
});

const mapDispatchToProps = {
  onResize: categoryActions.resizeLayout,
};

const mergeProps = (
  sP: ReturnType<typeof mapStateToProps>,
  { onResize }: typeof mapDispatchToProps,
  { categoryId, elementId, ...oP }: Props
) => ({
  ...sP,
  ...oP,
  onResize: (percent: number) => onResize({ categoryId, percent, elementId }),
});

const connector = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export type CategoryLayoutElementContainerProps = ConnectedProps<
  typeof connector
>;

export default connector(CategoryLayoutElement);
